import React from 'react'
// libs
import { InjectedFormProps, reduxForm } from 'redux-form'
// components
import { ReduxInput, ReduxSelect } from 'components/FormElements'
// constants
import { Forms } from 'constants/forms'
import { DUE_DATE_NOW_OPTION, DUE_DATE_TO_OPTIONS, PLUS_TYPE_OPTIONS } from 'constants/field-recurrense'
// views
import { Form } from './views'
const INPUT_PROPS = { min: 0 }

interface Props {
  dueDateNowOnly?: boolean
}

const RecurrenceSettingsForm: React.FC<InjectedFormProps & Props> = ({ dueDateNowOnly }) => {
  return (
    <Form>
      <span>
        Set <b>{`${dueDateNowOnly ? '' : 'Due'} Date`}</b> to
      </span>
      <ReduxSelect name='dueDateAt' options={dueDateNowOnly ? [DUE_DATE_NOW_OPTION] : DUE_DATE_TO_OPTIONS} />
      <span>plus</span>
      <ReduxInput name='plus' type='number' inputProps={INPUT_PROPS} />
      <ReduxSelect name='plusType' options={PLUS_TYPE_OPTIONS} />
    </Form>
  )
}

export default reduxForm<any, any>({
  form: Forms.RISK_FIELD_RECURRENCE_FORM,
  enableReinitialize: true
})(RecurrenceSettingsForm)
